import { useEffect, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import "./pendingReview.scss";
import {
  collectionGroup,
  doc,
  getCountFromServer,
  getDocs,
  limit,
  query,
  startAfter,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Rating,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { reviewColumn } from "../../datatablesource";
import { ProgressDialog } from "../../components/modal";

const PAGE_SIZE = 10;
let lastVisible = null;

const PendingReview = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [dataCache, setDataCache] = useState({});
  const [reviewDialog, setReviewDialog] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [progressLoading, setProgressLoading] = useState(false);

  useEffect(() => {
    const fetchTotalPages = async () => {
      const eLibraryRef = query(
        collectionGroup(db, "reviews"),
        where("status", "==", "pending")
      );
      const totalDocuments = await getCountFromServer(eLibraryRef);
      const totalDataCount = totalDocuments.data().count;
      setTotalPages(Math.ceil(totalDataCount / PAGE_SIZE));
    };
    fetchTotalPages();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      let newData;

      if (dataCache[page]) {
        newData = dataCache[page];
      } else {
        let userQuery;

        if (page === 0) {
          lastVisible = null;
        }

        if (lastVisible != null && page !== 0) {
          userQuery = query(
            collectionGroup(db, "reviews"),
            where("status", "==", "pending"),
            startAfter(lastVisible),
            limit(PAGE_SIZE)
          );
        } else {
          userQuery = query(
            collectionGroup(db, "reviews"),
            where("status", "==", "pending"),
            limit(PAGE_SIZE)
          );
        }

        const querySnapshot = await getDocs(userQuery);
        lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];

        newData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setDataCache((prevCache) => ({ ...prevCache, [page]: newData }));
      }

      setData(newData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const openDetailedDialog = (review) => {
    console.log(review);
    setReviewDialog(review);
    setOpenDialog(true);
  };

  useEffect(() => {
    fetchData();
    console.log(dataCache)
  }, [page]);

  const performReviewAction = async (status) => {
    setProgressLoading(true);
    setOpenDialog(false);
    try {
      const docRef = doc(
        db,
        "eLibrary",
        reviewDialog.product_id,
        "reviews",
        reviewDialog.id
      );

      await updateDoc(docRef, {
        status: status,
      });
      window.location.reload();
      setProgressLoading(false);
    } catch (error) {
      console.error("Error performing review action:", error);
      setProgressLoading(false);
    }
  };

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 100,
      align: "right",
      headerAlign: "right",
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Button
              variant="outlined"
              onClick={() => openDetailedDialog(params.row)}
            >
              Open
            </Button>
          </div>
        );
      },
      sortable: false,
    },
  ];

  return (
    <div className="prlist">
      <Sidebar />
      <div className="prlistContainer">
        <Box p={"30px"}>
          <Typography
            fontSize={"20px"}
            sx={{ fontWeight: "medium", marginBottom: "10px" }}
          >
            Reviews
          </Typography>
          <Box sx={{ height: "80vh", paddingBottom: "10px" }}>
            <DataGrid
              disableColumnFilter
              disableColumnMenu
              className="datagrid"
              rows={data}
              localeText={{ noRowsLabel: 'No pending review available.' }}
              columns={reviewColumn.concat(actionColumn)}
              pagination
              pageSize={PAGE_SIZE}
              rowCount={totalPages * PAGE_SIZE}
              paginationMode="server"
              loading={loading}
              onPageChange={(newPage) => setPage(newPage)}
            />
          </Box>
        </Box>
        <Dialog
          open={openDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Review "}</DialogTitle>
          <DialogContent>
            <Box>
              <Rating name="read-only" value={reviewDialog.rating} readOnly />
              <Typography fontSize={"12px"}>
                {reviewDialog.review_text}
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenDialog(false);
              }}
            >
              Cancel
            </Button>
            <Button
              color="error"
              onClick={() => performReviewAction("rejected")}
            >
              Reject
            </Button>
            <Button
              color="success"
              onClick={() => performReviewAction("approved")}
              autoFocus
            >
              Approve Review
            </Button>
          </DialogActions>
        </Dialog>
        <ProgressDialog loading={progressLoading} message={"Please Wait..."} />
      </div>
    </div>
  );
};

export default PendingReview;
